export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14647.a1b3cbca.jpg";